import * as React from 'react'

import { F0TagStatus, NewColor, StatusVariant } from '@factorialco/f0-react'
import { AtsJobPostingStatusesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const statusLabel = (status: AtsJobPostingStatusesEnum) => {
  const statusLabels: Record<AtsJobPostingStatusesEnum, string> = {
    draft: i18n.t('ats.job_status.draft'),
    published: i18n.t('ats.job_status.active'),
    archived: i18n.t('ats.job_status.archived'),
    unlisted: i18n.t('ats.job_status.unlisted'),
    cancelled: i18n.t('ats.job_status.cancelled'),
    deleted: i18n.t('ats.job_status.deleted'),
  }

  return statusLabels[status]
}

export const statusColor = (status: AtsJobPostingStatusesEnum) => {
  const statusColors: Record<AtsJobPostingStatusesEnum, StatusVariant> = {
    draft: 'warning',
    published: 'positive',
    archived: 'neutral',
    unlisted: 'info',
    cancelled: 'critical',
    deleted: 'critical',
  }

  return statusColors[status]
}

export const statusDotColor = (status: AtsJobPostingStatusesEnum): NewColor => {
  const colors: Record<AtsJobPostingStatusesEnum, NewColor> = {
    draft: 'smoke',
    published: 'flubber',
    archived: 'smoke',
    unlisted: 'malibu',
    cancelled: 'barbie',
    deleted: 'barbie',
  }

  return colors[status]
}
interface Props {
  status: AtsJobPostingStatusesEnum
}

export const JobStatusTag = ({ status }: Props) => {
  return <F0TagStatus text={statusLabel(status)} variant={statusColor(status)} />
}
